import React from 'react';

if ( ENV.debug.root ) console.log ( 'map.fedokr.component.js' );

export const MapDistrict = (props) => (<><h2>Карта федерального округа</h2></>);
export default MapDistrict;
